import MapWrapper from "./components/Map/MapWrapper";
import DevNoticeBanner from "@components/UI/Banner/DevNoticeBanner";


const App = () => {
    return (
        <><DevNoticeBanner /><MapWrapper /></>
    );
};

export default App;